import React, { useState, useRef, useEffect } from "react";
import "./MultiSelect.css";

const workEnvironments = [
  { label: "Corporate", value: "corporate" },
  { label: "Start-up/Scale-up", value: "start-up/scale-up" },
  {
    label: "Entrepreneurial/Innovative",
    value: "entrepreneurial/innovative",
  },
  { label: "Mid-size", value: "mid-size" },
  { label: "Family-owned", value: "family-owned" },

  { label: "Other", value: "other" },
];

const preferredWorkEnvironment = [
  {
    label: "Fast-paced, goal-oriented and performance driven",
    value: "fast-paced, goal-oriented and performance driven",
  },
  {
    label: "Creative, energetic and socially engaging",
    value: "creative, energetic and socially engaging",
  },
  {
    label: "Calm, predictable, and cooperative",
    value: "calm, predictable, and cooperative",
  },
  {
    label: "Structured, organized and rule-based",
    value: "structured, organized and rule-based",
  },
];

const MultiSelect = ({
  value,
  onChange,
  disabled = false,
  options = workEnvironments,
}) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const containerRef = useRef(null);
  const inputRef = useRef(null);

  const toggleOption = (val) => {
    if (value.includes(val)) {
      onChange(value.filter((v) => v !== val));
    } else {
      onChange([...value, val]);
    }
    setSearchTerm("");
  };

  const filteredOptions = options.filter((env) =>
    (env.label || "").toLowerCase().includes(searchTerm.toLowerCase()),
  );

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (containerRef.current && !containerRef.current.contains(e.target)) {
        setDropdownOpen(false);
      }
    };

    // Use mousedown to catch clicks before React events
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // Handle Backspace to remove last selected item
  const handleKeyDown = (e) => {
    if (e.key === "Backspace" && searchTerm === "" && value.length > 0) {
      const lastValue = value[value.length - 1];
      onChange(value.filter((v) => v !== lastValue));
    }
  };

  return (
    <div className="multi-select-container" ref={containerRef}>
      <div
        className={`selected-items ${disabled ? "disabled" : ""}`}
        onClick={() => !disabled && setDropdownOpen(true)}
      >
        {value.map((val) => {
          const label = options.find((w) => w.value === val)?.label;
          return (
            <span key={val} className="tag">
              {label}
              {!disabled && (
                <span
                  className="remove"
                  onClick={(e) => {
                    e.stopPropagation();
                    toggleOption(val);
                  }}
                >
                  ×
                </span>
              )}
            </span>
          );
        })}
        {!disabled && (
          <input
            ref={inputRef}
            type="text"
            placeholder={
              value.length === 0 ? "Select preferred company type" : ""
            }
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            onFocus={() => setDropdownOpen(true)}
            onKeyDown={handleKeyDown}
          />
        )}
      </div>

      {dropdownOpen && !disabled && (
        <div className="options-list">
          {filteredOptions.length > 0 ? (
            filteredOptions.map((env) => {
              const selected = value.includes(env.value);
              return (
                <div
                  key={env.value}
                  onClick={() => toggleOption(env.value)}
                  className={`option-item ${selected ? "selected" : ""}`}
                >
                  <input
                    type="checkbox"
                    checked={selected}
                    readOnly
                    className="checkbox"
                    style={{ pointerEvents: "none", display: "none" }}
                  />
                  {env.label}
                </div>
              );
            })
          ) : (
            <div className="no-options">No results found</div>
          )}
        </div>
      )}
    </div>
  );
};

export default MultiSelect;
export { preferredWorkEnvironment };
